import { createRouter, createWebHistory } from 'vue-router';
import Home from './screens/Home.vue';
import LegalNotices from './screens/LegalNotices.vue';
import Actualite from './screens/Actualite.vue';
import ActualiteDetails from './screens/ActualiteDetails.vue';
import Confidentialites from './screens/Confidentialites.vue';
import Cookies from './screens/Cookies.vue';
import AdminLogin from './screens/admin/Login.vue';
import AdminDashboard from './screens/admin/Dashboard.vue';

const routes = [
    {
        path: '/',
        name: 'Home',
        component: Home,
        meta: {
            title: 'AMGO - Association des Médecins Généralistes d\'Oran',
            description: 'Promouvoir l\'excellence médicale et renforcer la solidarité professionnelle des médecins de famille à Oran.',
        },
    },
    {
        path: '/legal-notices',
        name: 'legal',
        component: LegalNotices,
        meta: {
            title: 'Mentions légales - AMGO',
            description: 'Mentions légales de l\'Association des Médecins Généralistes d\'Oran.',
        },
    },
    {
        path: '/politique-confidentialites',
        name: 'pconfidentialites',
        component: Confidentialites,
        meta: {
            title: 'Politique de confidentialité - AMGO',
            description: 'Politique de confidentialité et protection des données personnelles de l\'AMGO.',
        },
    },
    {
        path: '/cookies',
        name: 'cookies',
        component: Cookies,
        meta: {
            title: 'Cookies - AMGO',
            description: 'Politique d\'utilisation des cookies sur le site de l\'AMGO.',
        },
    },
    {
        path: '/actualites',
        name: 'actualites',
        component: Actualite,
        meta: {
            title: 'Actualités - AMGO',
            description: 'Retrouvez les dernières actualités de l\'Association des Médecins Généralistes d\'Oran.',
        },
    },
    {
        path: '/actualites/:idOrSlug',
        name: 'actualite-details',
        component: ActualiteDetails,
        props: true,
        meta: {
            title: 'Actualité - AMGO',
            description: 'Détail de l\'actualité - Association des Médecins Généralistes d\'Oran.',
        },
    },
    {
        path: '/admin',
        name: 'admin-login',
        component: AdminLogin,
        meta: {
            title: 'Administration - AMGO',
            description: 'Espace d\'administration AMGO.',
        },
    },
    {
        path: '/admin/dashboard',
        name: 'admin-dashboard',
        component: AdminDashboard,
        meta: {
            title: 'Dashboard - AMGO Admin',
            description: 'Tableau de bord d\'administration AMGO.',
        },
    },
];

const router = createRouter({
    history: createWebHistory(),
    routes,
});

const SITE_URL = 'https://amgo.213devops.com';
const DEFAULT_IMAGE = `${SITE_URL}/assets/logo.png`;

function ensureMeta(selector, attrName, attrValue) {
    let tag = document.querySelector(selector);
    if (!tag) {
        tag = document.createElement('meta');
        tag.setAttribute(attrName, attrValue);
        document.head.appendChild(tag);
    }
    return tag;
}

function ensureLink(rel) {
    let tag = document.querySelector(`link[rel="${rel}"]`);
    if (!tag) {
        tag = document.createElement('link');
        tag.setAttribute('rel', rel);
        document.head.appendChild(tag);
    }
    return tag;
}

export function setMetaTags({ title, description, url, image }) {
    const defaultTitle = 'AMGO - Association des Médecins Généralistes d\'Oran';
    const defaultDesc = 'Promouvoir l\'excellence médicale et renforcer la solidarité professionnelle des médecins de famille.';

    const finalTitle = title || defaultTitle;
    const finalDesc = description || defaultDesc;
    const finalUrl = url || (typeof window !== 'undefined' ? window.location.href : SITE_URL);
    const finalImage = image || DEFAULT_IMAGE;

    document.title = finalTitle;
    ensureMeta('meta[name="description"]', 'name', 'description').setAttribute('content', finalDesc);
    ensureMeta('meta[property="og:title"]', 'property', 'og:title').setAttribute('content', finalTitle);
    ensureMeta('meta[property="og:description"]', 'property', 'og:description').setAttribute('content', finalDesc);
    ensureMeta('meta[property="og:url"]', 'property', 'og:url').setAttribute('content', finalUrl);
    ensureMeta('meta[property="og:image"]', 'property', 'og:image').setAttribute('content', finalImage);
    ensureMeta('meta[name="twitter:title"]', 'name', 'twitter:title').setAttribute('content', finalTitle);
    ensureMeta('meta[name="twitter:description"]', 'name', 'twitter:description').setAttribute('content', finalDesc);
    ensureMeta('meta[name="twitter:image"]', 'name', 'twitter:image').setAttribute('content', finalImage);
    ensureLink('canonical').setAttribute('href', finalUrl);
}

router.afterEach((to) => {
    setMetaTags({
        title: to.meta && to.meta.title,
        description: to.meta && to.meta.description,
        url: SITE_URL + to.fullPath,
    });
});

export default router;
